import React, { useMemo, useCallback, useState, useEffect, useRef } from 'react'
import { useTable } from 'react-table'
import { FixedSizeList } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import clsx from 'clsx'
import { deleteRole } from '@vt/apis/lib-ex/v2/role'
import { Toast } from '@ow/comps'
import RoleItem from './RoleItem'
import EditRole from './OperationRole'

const RoleTable = function ({ appId, roles, rolesMutate }) {
  const popupRef = useRef(null)
  const [currentRole, setCurrentRole] = useState({})
  const datas = useMemo(() => roles || [], [roles])
  const columns = useMemo(
    () => [
      {
        id: 'name',
        Header: '角色',
        accessor: 'name',
      },
      {
        id: 'mark',
        Header: '角色标记',
        accessor: 'mark',
      },
      {
        id: 'orgs',
        Header: '所属组织',
        accessor: 'orgs',
      },
      {
        id: 'userCount',
        Header: '用户数量',
        accessor: 'userCount',
      },
      {
        id: 'operate',
        Header: '操作',
        accessor: 'operate',
      },
    ],
    [roles]
  )

  const updateCurrentRole = (v) => {
    setCurrentRole(v)
  }

  // 删除需加二次确认
  const onConfirmDeleteRole = (role) => {
    deleteRole(appId, role.id).then(() => {
      Toast.success({
        title: '通知',
        description: '操作成功！',
      })
      // setIsVisibleDelete(false)
      rolesMutate()
    })
  }

  const tableInstance = useTable({ columns, data: datas || [] })
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = tableInstance

  const renderRow = useCallback(
    ({ index, style }) => {
      const row = rows[index]
      prepareRow(row)
      return (
        <RoleItem
          style={style}
          key={row.original.id}
          row={row}
          showEditRoleModal={() => {
            if (popupRef.current) {
              popupRef.current.open()
            }
          }}
          updateCurrentRole={updateCurrentRole}
          deleteRole={onConfirmDeleteRole}
          rolesMutate={rolesMutate}
        />
      )
    },
    [prepareRow, rows, selectedFlatRows]
  )

  // 解决火狐浏览器高度的问题
  useEffect(() => {
    const str = navigator.userAgent
    if (str.indexOf('Firefox') > -1) {
      document.getElementById('role-list').style.height = `${
        document.body.clientHeight - 180
      }px`
    }
  }, [])
  return (
    <>
      <div
        className="w-full flex-1 relative"
        style={{
          overflowX: 'auto',
          // height: 'calc(100% - 3rem)',
          fontSize: '13px',
          color: '#526484',
        }}
      >
        <div
          {...getTableProps()}
          className="table w-full h-full overflow-x-auto sm:overflow-x-visible"
          style={{ position: 'relative' }}
        >
          <div style={{ position: 'relative', top: '0', left: '0' }}>
            {headerGroups.map((headerGroup) => {
              return (
                <div
                  {...headerGroup.getHeaderGroupProps()}
                  key={headerGroup.headers}
                  className="flex pl-4"
                  style={{
                    fontSize: '13px',
                    borderBottom: '1px solid #dbdfea',
                    borderTop: '1px solid #dbdfea',
                  }}
                >
                  {headerGroup.headers.map((column) => {
                    return (
                      <div
                        {...column.getHeaderProps()}
                        key={column.id}
                        className={clsx([
                          {
                            'w-32 lg:w-1/4':
                              column.id !== 'selection' && column.id !== 'orgs',
                            'w-10': column.id === 'selection',
                            'w-1/3': column.id === 'orgs',
                          },
                          'flex items-center p-2',
                        ])}
                      >
                        <b>{column.render('Header')}</b>
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
          <div
            {...getTableBodyProps()}
            style={{ height: 'calc(100% - 5.1125rem)' }}
            id="role-list"
          >
            {rows.length > 0 ? (
              <AutoSizer>
                {({ height, width }) => {
                  return (
                    <FixedSizeList
                      height={height}
                      itemCount={rows.length}
                      itemSize={47}
                      width={width}
                    >
                      {renderRow}
                    </FixedSizeList>
                  )
                }}
              </AutoSizer>
            ) : (
              <span>暂无数据</span>
            )}
          </div>
        </div>
        <div
          className="w-full px-5 text-gray-600 text-xs flex items-center absolute left-0 bottom-0"
          style={{ height: '2.25rem' }}
        >
          共查询到{(datas || []).length}条数据
        </div>
      </div>

      <EditRole
        edit
        appId={appId}
        currentRole={currentRole}
        rolesMutate={rolesMutate}
        closeModal={() => {
          if (popupRef.current) {
            popupRef.current.close()
          }
        }}
        ref={popupRef}
      />
    </>
  )
}

export default RoleTable
